import { useEffect, useRef, useState } from 'react';
import { FiMenu, FiX } from 'react-icons/fi';
import { FaDiscord, FaInstagram, FaPatreon, FaTiktok, FaYoutube } from 'react-icons/fa';
import { Link, NavLink, useLocation } from 'react-router-dom';
import './styles.css';

export const Header = () => {
  const [open, setOpen] = useState(false);
  const toggleRef = useRef<HTMLButtonElement>(null);
  const headerRef = useRef<HTMLElement>(null);
  const { pathname } = useLocation();
  useEffect(() => { setOpen(false); }, [pathname]);
  useEffect(() => {
    const closeOnEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape' && open) { setOpen(false); toggleRef.current?.focus(); }
    };
    document.addEventListener('keydown', closeOnEscape);
    return () => document.removeEventListener('keydown', closeOnEscape);
  }, [open]);
  return <header className="App-header" ref={headerRef} onBlur={event => { if (!event.currentTarget.contains(event.relatedTarget as Node)) setOpen(false); }}>
    <div className="header-container page-width">
      <Link className="brand" to="/" aria-label="Slick Slicer home"><img width="34" height="34" src="/slick2.png" alt="" /><span>slick<span className="brand-dot">.</span></span></Link>
      <button ref={toggleRef} className="menu-toggle" aria-label={open ? 'Close navigation' : 'Open navigation'} aria-expanded={open} aria-controls="site-navigation" onClick={() => setOpen(value => !value)}>{open ? <FiX /> : <FiMenu />}</button>
      <nav id="site-navigation" aria-label="Main navigation" className={`header-buttons${open ? ' is-open' : ''}`}>
        <NavLink to="/" end onClick={() => setOpen(false)}>Overview</NavLink><NavLink to="/download" onClick={() => setOpen(false)}>Download</NavLink><NavLink to="/pricing" onClick={() => setOpen(false)}>Pricing</NavLink><NavLink to="/faq" onClick={() => setOpen(false)}>FAQ</NavLink><NavLink to="/contact" onClick={() => setOpen(false)}>Contact</NavLink>
        <div className="header-socials">
          <a href="https://discord.gg/TPrDj9rYm" target="_blank" rel="noopener noreferrer" aria-label="Slick Slicer on Discord" title="Discord"><FaDiscord aria-hidden="true" /></a>
          <a href="https://www.youtube.com/@SlickSlicer-g8z" target="_blank" rel="noopener noreferrer" aria-label="Slick Slicer on YouTube" title="YouTube"><FaYoutube aria-hidden="true" /></a>
          <a href="https://www.tiktok.com/@slickslicer35" target="_blank" rel="noopener noreferrer" aria-label="Slick Slicer on TikTok" title="TikTok"><FaTiktok aria-hidden="true" /></a>
          <a href="https://www.instagram.com/slick.slicer/" target="_blank" rel="noopener noreferrer" aria-label="Slick Slicer on Instagram" title="Instagram"><FaInstagram aria-hidden="true" /></a>
          <a href="https://www.patreon.com/cw/SlickSlicer/membership" target="_blank" rel="noopener noreferrer" aria-label="Slick Slicer on Patreon" title="Patreon"><FaPatreon aria-hidden="true" /></a>
        </div>
      </nav>
    </div>
  </header>;
};
